import Grid from "@material-ui/core/Grid";
import React from "react";
import { FlyerDetailPageTabDetailsNameProps } from "./flyer-detail-page-tab-page-details-name.props";
import { Name } from "./flyer-detail-page-tab-page-details-name.styles";

export const FlyerDetailPageTabPageDetailsName = (props: FlyerDetailPageTabDetailsNameProps) => (
  <Grid
    item={true}
    xs={1}
    sm={1}
    md={1}
    lg={1}
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === "Enter") {
        props.onClick();
      }
    }}
  >
    <Name onClick={props.onClick}>{props.children}</Name>
  </Grid>
);
